import { useFlag } from '@automata/utils/hooks';
import { useMemo } from 'react';

export const useGetInstrumentsConfigState = (workcellId: string) => {
  const isIgnoreErrorsSftpConfigEnabled =
    useFlag('fe.enable_ignore_errors_sftp_config') ?? false;

  const instrumentStates: Record<
    string,
    Record<string, Record<string, boolean>>
  > = useMemo(
    () => ({
      azProd: {
        sftp: {
          ignore_errors: isIgnoreErrorsSftpConfigEnabled,
        },
      },
    }),
    [isIgnoreErrorsSftpConfigEnabled]
  );

  return instrumentStates[workcellId] ?? {};
};
